import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import Router from 'vue-router';
import Home from "./views/Home.vue";
import Search from "./views/Search.vue";
import Account from './views/Account.vue';
import Recipes from './views/Recipes.vue';
import Tagged from './views/Tagged.vue';
import Recipe from "./views/Recipe.vue";
import RecipeShared from "./views/RecipeShared.vue";
import Meal from "./views/Meal.vue";
import Menu from './views/Menu.vue';
import Meals from "./views/Meals.vue";
//import CreateRecipe from './views/CreateRecipe.vue';
import CreateRecipe2 from './views/CreateRecipe2.vue';
import Kitchen from './views/Kitchen.vue';
import MyKitchen from './views/MyKitchen.vue';
import EditMeal from "./views/EditMeal.vue";
import EditMenu from './views/EditMenu.vue';
// import EditRecipe from './views/EditRecipe.vue';
import EditRecipe2 from "./views/EditRecipe2.vue";
import AdaptRecipe from "./views/AdaptRecipe.vue";
import PageNotFound from '@/views/404.vue';
import Login from '@/views/Login';
import ResetPassword from '@/views/ResetPassword';
import SignUp from '@/views/SignUp';
import Checkout from '@/views/Checkout';

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/search",
      name: "Search",
      component: Search
    },
    {
      path: "/create-recipe",
      name: "Create Recipe",
      component: CreateRecipe2,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/:id",
      name: "edit",
      component: EditRecipe2,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/adapt/:id",
      name: "adapt",
      component: AdaptRecipe,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit-meal/:id",
      name: "edit-meal",
      component: EditMeal,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit-menu/:id",
      name: "edit-menu",
      component: EditMenu,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/resetpassword",
      name: "ResetPassword",
      component: ResetPassword
    },
    {
      path: "/checkout",
      name: "Checkout",
      component: Checkout,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/sign-up",
      name: "SignUp",
      component: SignUp
    },
    {
      path: "/kitchen/:id",
      name: "Kitchen",
      component: Kitchen
    },
    {
      path: "/kitchen",
      name: "MyKitchen",
      component: MyKitchen,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/recipes",
      name: "Browse Recipes",
      component: Recipes
    },
    {
      path: "/tagged/:id",
      name: "tagged",
      component: Tagged
    },
    {
      path: "/recipe/:id/:slug",
      name: "recipe",
      component: Recipe
    },
    {
      path: "/recipe/:id",
      name: "recipeShared",
      component: RecipeShared
    },
    {
      path: "/meals",
      name: "meals",
      component: Meals,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/meal/:id/:slug",
      name: "meal",
      component: Meal
    },
    {
      path: "/meal/:id",
      name: "meal-alt",
      component: Meal
    },
    {
      path: "/menu/:id/:slug",
      name: "menu",
      component: Menu
    },
    {
      path: "/menu/:id",
      name: "menu-alt",
      component: Menu
    },
    {
      path: "/account",
      name: "Account",
      component: Account,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "*",
      component: PageNotFound
    }
  ]
});


router.beforeEach((to,from,next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  firebase.auth().onAuthStateChanged(function(user) {
    if (requiresAuth && !user)  next('/login');
    else if (!requiresAuth && user) next();
    else next();
  });
  
});

export default router;
